export default __webpack_public_path__ + "static/media/make5.5286082e.png";